export class UserLoginResult
{
    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }

        // Handle any custom mappings here or use getters and setters. Object.assign will call
        // property setters.
    }

    public Token!: string;
    public Expiration!: string;
    public RefreshToken!: string;
    public RefreshTokenExpiration!: string;
}
